import React, { PureComponent } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { connect } from 'react-redux';
import { decorators, DataRow, getPaginator } from '@orange-marmalade/paginate-this';
import cx from 'classnames';

// ducks
import { paginateThis } from '../../ducks/AgentSearch';

// components
import LoadError from '../../components/load-error/load-error';

// contianers
import AgentResult from './AgentResult';

// modules
import BS from '../../theme/Bootstrap';

class AgentSearchResults extends PureComponent {
  render() {
    const { ids, className, isLoading, loadError, reload } = this.props;

    return (
      <Container className={cx(className, BS.flex1, BS.positionRelative)}>
        <Row className={`${BS.justifyContentStart}`}>
          {ids.map((id, i) => {
            return (
              <Col xs={12} sm={6} lg={4} className={`${BS.mb3}`} key={i}>
                <DataRow itemId={id} component={AgentResult} index={i} />
              </Col>
            );
          })}
          {loadError && !isLoading && (
            <Col xs={12}>
              <LoadError error={loadError} retry={reload} />
            </Col>
          )}
          {ids.length === 0 && !isLoading && !loadError && (
            <Col xs={12} className={`${BS.mb3} ${BS.textCenter}`}>
              No Results
            </Col>
          )}
        </Row>
        {isLoading && <div className={BS.loadingMask}>LOADING</div>}
      </Container>
    );
  }
}

export default decorators.tabulateLean(
  connect(
    (state, props) => {
      const paginator = getPaginator(props.listId, state),
        loadError = paginator.get('loadError');

      return {
        loadError
      };
    },
    {
      reload: paginateThis.pageActions.reload
    }
  )(AgentSearchResults)
);



// WEBPACK FOOTER //
// ./src/containers/AgentSearch/AgentSearchResults.js